import { InfoCircleFilled } from '@ant-design/icons';
import { Card as AntdCard, Tooltip } from 'antd';
import { PropsWithChildren } from 'react';
import { Spinner } from '../../../../components';


const Content: React.FC<PropsWithChildren<{ isLoading: boolean, className?: string }>> = ({ children, className, isLoading }) => {
  if (isLoading) {
    return (
      <div className={`flex-1 ${className}`}>
        <Spinner width="50px" height="50px" />
      </div>
    );
  }
  return (
    <div className={`flex-1 ${className}`}>
      {children}
    </div>
  );
};

const Header: React.FC<{ title: string; tooltip: string }> = ({
  title,
  tooltip,
}) => {
  return (
    <div className="flex items-center justify-between px-6">
      <span>{title}</span>
      <Tooltip title={tooltip}>
          <InfoCircleFilled className={`ml-2 text-[#293241] self-start pt-1.5`} />
      </Tooltip>
    </div>
  );
};

const Block: React.FC<PropsWithChildren<{ className?: string }>> = ({
  className,
  children,
}) => {
  return (
    <div className={`flex flex-col gap-2 ${className}`}>
        {children}
    </div>
  );
};

const ApplicationReportCard: React.FC<PropsWithChildren<{ className?: string }>> = ({ children, className }) => {
  const classNames = `grid [grid-template-columns:repeat(auto-fit,_minmax(215px,_1fr))] max-[width:5*215px] divide-x divide-[#E2E2E2] overflow-hidden h-full ${className || ''}`.trim();
  return (
    <AntdCard bodyStyle={{ padding: '24px 0px', height: '100%' }} style={{ backgroundColor: '#F5F5F5', height: '200px' }}>
      <div className={classNames}>
        {children}
      </div>
    </AntdCard>
  );
};

export const Card = Object.assign(ApplicationReportCard, {
    Block: Block,
    Header: Header,
    Content: Content,
});